const zh = {
    '公告': "公告",
    '公告管理': "公告管理",
    '添加公告': "添加公告",
    '排序': "排序",
    '标题': "标题",
    '是否首页弹出显示': "是否首页弹出显示",
    'banner图': "banner图",
    '详情图': "详情图",
    '操作': "操作",
    '是': "是",
    '否': "否",
    '编辑': "编辑",
    '删除': "删除",
    '开头重要通知': "开头重要通知",
    '普通文字内容': "普通文字内容",
    '结尾重要通知': "结尾重要通知",

    '验证码错误或者超时':'验证码错误或者超时',
    '手机号码已经被占用,请更换手机号':'手机号码已经被占用,请更换手机号',

    '暂时不能交易[1001]': '暂时不能交易',
    '无效的邀请码': '无效的邀请码',
    '无效访问，请重新登录': '无效访问，请重新登录',

    '管理员': "管理员",
    '代理商': "代理商",
    '客户': "客户",
    '正常': "正常",
    '已注销': "已注销",
    '个': "个",
    '当前净值': "当前净值",
    '当前浮动盈亏': "当前浮动盈亏",

    '下载客户端': "下载客户端",
    '立即下载': "立即下载",
    '用户提示': "用户提示",
    '点击屏幕右上角': "点击屏幕右上角",
    '选择在Safari中打开': "选择在Safari中打开",
    '安卓': "安卓",
    '安卓 ZT辅助器': "安卓 ZT辅助器",
    '请使用Iphone设备下载': "请使用Iphone设备下载",

    

    '当前浮动盈亏': "当前浮动盈亏",

    '添加子账户': "添加子账户",
    '用户名': "用户名",
    '权限管理': "权限管理",
    '修改下级客户': "修改下级客户",
    '删除': "删除",
    '无效访问，请重新登录': "无效访问，请重新登录",

    '发送': "发送",
    '手机,昵称,姓名': "手机,昵称,姓名",

    "所有聊天": "所有聊天",
    "欢迎使用": "欢迎使用",
    "发给": "发给",

    '审核完成': "审核完成",
    '推广开户': "推广开户",
    '分组': "分组",
    '邀请码': "邀请码",
    '开户链接': "开户链接",
    '修改密码成功': "修改密码成功",

    '入金最少': "入金最少",
    '入金最多': "入金最多",

    '更新信息成功': "更新信息成功",
    '时间类型': "时间类型",
    '出金金额过小': "出金金额过小",
    '出金金额过大': "出金金额过大",
    '操作过于频繁': "操作过于频繁",

    '在线咨询': "在线咨询",
    '聊天': "聊天",
    '本账号': "本账号",

    '剩余可用资金不足，无法出金': "剩余可用资金不足，无法出金",
    '验证码不正确': "验证码不正确",
    '出金成功，等待管理员审核': "出金成功，等待管理员审核",

    '地区': "地区",
    '身份证': "身份证",
    '银行卡': "银行卡",
    '激活客户': "激活客户",
    '未激活客户': "未激活客户",
    '转账': "转账",
    '平仓表单不完整': "平仓表单不完整",
    '平仓量超出限制': "平仓量超出限制",
    '是否确认平仓': "是否确认平仓",
    '修改信息': "修改信息",
    '昵称': "昵称",
    '平仓委托已市价提交': "平仓委托已市价提交",
    '平仓委托已市价成交': "平仓委托已市价成交",
    '认购成功': "认购成功",
    '可用资金不足，请充值后在进行认购': "可用资金不足，请充值后在进行认购",
    '手数不合理，请重新输入': "手数不合理，请重新输入",
    '入金状态': "入金状态",
    '出金状态': "出金状态",
    '请选择出金状态': "请选择出金状态",

    '登录成功': "登录成功",
    '登陆成功': "登陆成功",
    '账号或密码错误': "账号或密码错误",
    '验证码错误或超时': "验证码错误或超时",
    '账号注册成功': "账号注册成功",
    '实名认证': "实名认证",

    '客户信息': "客户信息",
    '上级': "上级",
    '返佣等级': "返佣等级",
    '通过': "通过",
    '手动入金': "手动入金",
    '支付订单号': "支付订单号",
    '申请时间': "申请时间",
    '审核时间': "审核时间",
    '手动出金': "手动出金",

    '总入金': "总入金",
    '总出金': "总出金",
    '出金id': "出金id",
    '入金id': "入金id",
    '保证金总额': "保证金总额",
    '保证金变动': "保证金变动",
    '手续费': "手续费",
    '正常入金': "正常入金",
    '库存费': "库存费",
    '正常出金': "正常出金",


    '盈利': "盈利",
    '亏损': "亏损",
    '保证金清空': "保证金清空",
    '驳回出金': "驳回出金",
    '平仓手续费': "平仓手续费",
    '申请出金': "申请出金",
    '申请出金': "申请出金",



    '入金最少100元': '入金最少100元',
    '场外USDT入金': '场外USDT入金',
    '将会把您的USDT购买订单发送给NEWMONEY场外数字货币交易平台，NEWMONEY将会自动匹配一位USDT卖家给您，您只需要根据卖家提供的银行卡信息转账给该卖家，等待卖家确认收到您的法币之后，卖家将会自动把该笔USDT释放给': '将会把您的USDT购买订单发送给NEWMONEY场外数字货币交易平台，NEWMONEY将会自动匹配一位USDT卖家给您，您只需要根据卖家提供的银行卡信息转账给该卖家，等待卖家确认收到您的法币之后，卖家将会自动把该笔USDT释放给',
    '会根据订单信息自动将该笔USDT划入您在': '会根据订单信息自动将该笔USDT划入您在',
    '的账户里': '的账户里',
    '注意：点击确认即代表您清楚场外USDT入金这一方式并确认过程中自动订单处理系统中的一系列划转过程': '注意：点击确认即代表您清楚场外USDT入金这一方式并确认过程中自动订单处理系统中的一系列划转过程',
    '请确认密码': '请确认密码',
    '开启': '开启',
    '隐藏': '隐藏',
    '止盈或止损价格不合理': '止盈或止损价格不合理',
    '止盈数据错误': '止盈数据错误',
    '止损数据错误': '止损数据错误',
    '平台返佣等级不可修改': '平台返佣等级不可修改',
    '取消返佣等级': '取消返佣等级',
    '没有查询到对应用户': '没有查询到对应用户',
    '审核通过': '审核通过',
    '禁止开仓': '禁止开仓',
    '审核不通过': '审核不通过',
    '第': '第',
    '层': '层',
    '没有找到下级用户': '没有找到下级用户',
    '请选择入金状态': '请选择入金状态',
    '无': '无',
    '未审核': '未审核',
    '审核通过': '审核通过',
    '输入不能为空': '输入不能为空',
    '合计': '合计',
    '手': '手',
    '万手': '万手',
    '亿': '亿',
    '未开通此功能，请联系管理员': '未开通此功能，请联系管理员',
    '产品规格': "产品规格",
    '最近浏览': "最近浏览",
    '市场深度': "市场深度",
    '自选列表': "自选列表",
    '下载客户端': "下载客户端",
    '确认密码与新密码不一致': "确认密码与新密码不一致",
    '字段不能为空': "字段不能为空",
    '手机号格式不正确': "手机号格式不正确",
    '请输入手机号': "请输入手机号",
    '获取验证码': "获取验证码",
    '邀请码不能为空': "邀请码不能为空",
    '密码不能为空': "密码不能为空",
    '确认密码不能为空': "确认密码不能为空",
    '手机号不能为空': "手机号不能为空",
    '验证码不能为空': "验证码不能为空",
    '手机号为空': "手机号为空",
    '剩余': "剩余",
    '秒': "秒",
    '获取验证码': "获取验证码",
    '关键词不能为空': "关键词不能为空",
    '搜索条件': "搜索条件",
    '关键词': "关键词",
    '不能为空': "不能为空",
    '未读消息': "未读消息",
    '条': "条",
    '请输入密码': "请输入密码",
    '请输入验证码': "请输入验证码",
    '我的': "我的",
    '已审核': '已审核',
    '未审核': "未审核",
    '成功': "成功",
    '驳回': "驳回",
    '优先资金': "优先资金",
    '提交': "产品规格",
    '手机号,邮箱,姓名': "手机号,邮箱,姓名",
    '账户转账': "账户转账",
    '关键词': "关键词",
    '数额': "数额",
    '关闭': "关闭",
    '提交': "提交",
    '表单不完整': "表单不完整",
    '出金方式': "出金方式",
    '备注': "备注",
    '操作': "操作",
    '订单号': "订单号",
    '姓名': "姓名",
    '实名状态': "实名状态",
    '创建时间': "创建时间",
    '角色': "角色",
    '余额': "余额",
    '账户状态': "账户状态",
    '账户状态': "账户状态",
    '手机号': "手机号",
    '分组': "分组",
    '商品名称': "商品名称",
    '商品代码': "商品代码",
    '委托数量': "委托数量",
    '成交额': "成交额",
    '方向': "方向",
    '手续费': "手续费",
    '建仓价': "建仓价",
    '委托建仓时间': "委托建仓时间",
    '建仓时间': "建仓时间",
    '建仓方式': "建仓方式",
    '平仓价': "平仓价",
    '平仓时间': "平仓时间",
    '委托平仓时间': "委托平仓时间",
    '平仓方式': "平仓方式",
    '净盈亏': "净盈亏",
    '平仓类型': "平仓类型",
    '到期日期': "到期日期",
    '市场类型': "市场类型",
    '所属机构': "所属机构",
    '委托类型': "委托类型",
    '建仓委托': "建仓委托",
    '平仓委托': "平仓委托",
    '收盘均价': "收盘均价",
    '市价': "市价",
    '限价': "限价",
    '时段均价': "时段均价",
    '邮箱或手机号': "邮箱或手机号",
    '名称或代码': "名称或代码",
    '搜索条件': "搜索条件",
    '关键词': "关键词",
    '品种': "品种",
    '开始时间': "开始时间",
    '结束时间': "结束时间",
    '额外设置': "额外设置",
    '是否包括下级': "是否包括下级",
    '分组': "分组",
    '下拉选择分组': "下拉选择分组",
    '提交': "提交",
    '统计': "统计",
    '用户数': "用户数",
    '买入数量': "买入数量",
    '卖出数量': "卖出数量",
    '成交额': "成交额",
    '手续费': "手续费",
    '库存费': "库存费",
    '条目': "条目",
    '浮动盈亏': "浮动盈亏",
    '平仓': "平仓",
    '平仓设置': "平仓设置",
    '订单ID': "订单ID",
    '股票代码': "股票代码",
    '股票名称': "股票名称",
    '平仓数量': "平仓数量",
    '平仓交易方式': "平仓交易方式",
    '请选择平仓方式': "请选择平仓方式",
    '平仓价': "平仓价",
    '选择用户': "选择用户",
    '保存': "保存",
    '取消': "取消",
    '交易详情': "交易详情",
    '概览': "概览",
    '持仓查询': "持仓查询",
    '库存费': "库存费",
    '当前价': "当前价",
    '浮动盈亏': "浮动盈亏",
    '买入': "买入",
    '卖出': "卖出",
    '平仓': "平仓",
    '驳回': "驳回",
    '撤委': "撤委",
    '修改个人信息': "修改个人信息",
    '修改邮箱': "修改邮箱",
    '修改手机号': "修改手机号",
    '实名认证': "实名认证",
    '已经实名': "已经实名",
    '柜台账号': "柜台账号",
    '姓名': "姓名",
    '未实名': "未实名",
    '身份证正面照片': "身份证正面照片",
    '身份证背面照片': "身份证背面照片",
    '银行卡号': "银行卡号",
    '银行卡信息': "银行卡信息",
    '银行卡照片': "银行卡照片",
    '法律声明': "法律声明",
    '用户协议': "用户协议",
    '关于反洗钱': "关于反洗钱",
    '已阅读': "已阅读",
    '未阅读': "未阅读",
    '已同意': "已同意",
    '未同意': "未同意",
    '清空表单': "清空表单",
    '修改邮箱': "修改邮箱",
    '身份证真人活体检测比对': "身份证真人活体检测比对",
    '用手机扫描二维码以进行本人身份证真人活体检测比对': "用手机扫描二维码以进行本人身份证真人活体检测比对",
    '密码长度最小为6位': "密码长度最小为6位",
    '邮箱': "邮箱",
    '身份证号': "身份证号",
    '身份证照正面': "身份证照正面",
    '点击上传': "点击上传",
    '身份证照背面': "身份证照背面",
    '所在地区': "所在地区",
    '开户支行': "开户支行",
    '银行卡照片': "银行卡照片",
    '法律声明': "法律声明",
    '已阅读': "已阅读",
    '用户协议': "用户协议",
    '关于反洗钱': "关于反洗钱",
    '已同意': "已同意",
    '立即创建': "立即创建",
    '重置': "重置",
    '已同意': "已同意",
    language: "中文",
    '姓名': "姓名",
    '银行': "银行",
    '开户行': "开户行",
    '银行卡号': "银行卡号",
    '金额': "金额",
    '转入信息': "转入信息",
    '订单号': "订单号",
    '支付方式': "支付方式",
    '状态': "状态",
    '时间': "时间",
    '备注': "备注",

    "日期": "日期",
    '前值': "前值",
    '今值': "今值",
    '预测值': "预测值",
    '万人': "万人",
    '手机号': "手机号",
    '密码': "密码",
    '验证码': "验证码",
    '登录': "登录",
    '注册': "注册",
    '忘记密码': "忘记密码",
    '新密码': "新密码",
    '确认密码': "确认密码",
    '获取验证码': "获取验证码",
    '提交': "提交",
    '清空表单': "清空表单",
    '推荐码': "推荐码",
    '邮箱': "邮箱",
    '原密码': "原密码",
    '密码长度最小为6位': "密码长度最小为6位",
    '两次密码不一致': "两次密码不一致",
    '邮箱格式不正确': "邮箱格式不正确",
    '请输入手机号': "请输入手机号",
    '手机号格式不正确': "手机号格式不正确",
    '股票资金流向': "股票资金流向",
    '中国CPI月报告': "中国CPI月报告",
    '期货仓单日报': "期货仓单日报",
    '美国EIA库存': "美国EIA库存",
    '美联储决议': "美联储决议",
    '美国非农报告': "美国非农报告",
    '全球法币热度': "全球法币热度",
    '数字货币概览': "数字货币概览",
    '查看更多': "查看更多",
    '操作': "操作",
    '移除自选': "移除自选",
    '统计': "统计",
    '金额总计': "金额总计",
    '条目': "条目",
    '提交': "提交",
    '关闭': "关闭",
    '姓名': "姓名",
    '银行': "银行",
    '开户行': "开户行",
    '银行卡号': "银行卡号",
    '金额': "金额",
    '转入信息': "转入信息",
    '订单号': "订单号",
    '支付方式': "支付方式",
    '状态': "状态",
    '备注': "备注",
    '市场快讯': "市场快讯",
    '财经日历': "财经日历",
    '交易排名': "交易排名",
    '股票': "股票",
    '指数': "指数",
    '商品': "商品",
    '期权': "期权",
    '数字货币': "数字货币",
    '法币': "法币",
    '时间': "时间",
    '名称': "名称",
    '交易对': "交易对",
    '最新价': "最新价",
    '涨跌幅': "涨跌幅",
    '涨跌': "涨跌",
    '涨跌价': "涨跌价",
    '现价': "现价",
    '买价': "买价",
    '卖价': "卖价",
    '买量': "买量",
    '卖量': "卖量",
    '成交量': "成交量",
    '成交额': "成交额",
    '持仓量': "持仓量",
    '日增': "日增",
    '开盘': "开盘",
    '最高': "最高",
    '最低': "最低",
    '昨收': "昨收",
    '交易所': "交易所",
    '代码': "代码",
    '合约简介': "合约简介",
    '最大交易量': "最大交易量",
    '交易量精度': "交易量精度",
    '交易时间': "交易时间",
    '合约大小': "合约大小",
    '最小交易量': "最小交易量",
    '价格精度': "价格精度",
    '看涨期权': "看涨期权",
    '看跌期权': "看跌期权",
    '全部股票': "全部股票",
    '期权交易': "期权交易",
    '请先完成实名认证': "请先完成实名认证",
    '点击认证': "点击认证",
    '自选为空': "自选为空",
    '首页': "首页",
    '市场': "市场",
    '自选': "自选",
    '资讯': "资讯",
    '我的': "我的",
    '请输入查询内容': "请输入查询内容",
    '行权周期': "行权周期",
    '名义本金': "名义本金",
    '万': "万",
    '元': "元",
    '手': "手",
    '预估为': "预估为",
    '类型': "类型",
    '成交方式': "成交方式",
    '始终以当前价格成交': "始终以当前价格成交",
    '限价': "限价",
    '报价比例': "报价比例",
    '支付金额': "支付金额",
    '立即认购': "立即认购",
    '请输入指定的价格': "请输入指定的价格",
    '关闭': "关闭",
    '提交': "提交",
    '目标金额': "目标金额",
    '点击入金': "点击入金",
    '选择入金方式': "选择入金方式",
    '选择出金方式': "选择出金方式",
    '入金金额': "入金金额",
    '银联': "银联",
    '支付宝': "支付宝",
    '在线支付': "在线支付",
    '银联': "银联",
    '比特币': "比特币",
    '场外USDT': "场外USDT",
    '银联转账': "银联转账",
    '支付': "支付",
    '注意：需按照订单金额使用本人支付宝账户进行扫码支付': "注意：需按照订单金额使用本人支付宝账户进行扫码支付",
    '点击出金': "点击出金",
    '调整范围': "调整范围",
    '请输入出金数额': "请输入出金数额",
    '请输入正确的数值': "请输入正确的数值",
    '请输入出金数额': "请输入出金数额",
    '超过出金限额': "超过出金限额",
    '交易': "交易",
    "客户管理": "客户管理",
    "出入金": "出入金",
    "报表查询": "报表查询",
    "系统设置": "系统设置",
    "当前权益": "当前权益",
    "可用资金": "可用资金",
    "持仓权利金": "持仓权利金",
    "持仓盈亏": "持仓盈亏",
    "当日入金": "当日入金",
    "当日出金": "当日出金",
    "二维码开户链接": "二维码开户链接",
    "出入金设置": "出入金设置",
    "期权认购": "期权认购",
    "客户列表": "客户列表",
    "客户行为": "客户行为",
    "异常比赛": "异常比赛",
    "入金": "入金",
    "出金": "出金",
    "入金列表": "入金列表",
    "出金列表": "出金列表",
    "委托单": "委托单",
    "持仓查询": "持仓查询",
    "成交记录": "成交记录",
    "统计报表": "统计报表",
    "资金流水": "资金流水",
    "返佣报表": "返佣报表",
    "角色管理": "角色管理",
    "组管理": "组管理",
    "返佣设置": "返佣设置",
    "机构管理": "机构管理",
    "日志": "日志",
    "系统参数": "系统参数",
    "子账户": "子账户",
    "个人信息": "个人信息",
    "修改密码": "修改密码",
    "退出账号": "退出账号",
    "净值,": "净值,",
    "浮动盈亏,": "浮动盈亏",
    "余额,": "余额",
    "可用余额,": "可用余额",
    "保证金,": "保证金",
    "安全度,": "安全度",
    "搜索条件": "搜索条件",
    "关键词": "关键词",
    "姓名,邮箱或手机号": "姓名,邮箱或手机号",
    "选择": "选择",
    "品种": "品种",
    "名称或代码": "名称或代码",
    "开始时间": "开始时间",
    "结束时间": "结束时间",
    "额外设置": "额外设置",
    "是否包括下级": "是否包括下级",
    "委托单类型": "委托单类型",
    "建仓委托": "建仓委托",
    "平仓委托": "平仓委托",
    "已锁定": "已锁定",
    "分组": "分组",
    "下拉选择分组": "下拉选择分组",
    "市场类型": "市场类型",
    "下拉选择市场类型": "下拉选择市场类型",
    "股票": "股票",
    "指数": "指数",
    "商品": "商品",
    "提交": "提交",
    "统计": "统计",
    "用户数": "用户数",
    "权利金": "权利金",
    "名义本金": "名义本金",
    "条目数": "条目数",
    "场外期权": "场外期权",
    "场内期权": "场内期权",
    "数字货币": "数字货币",
    "确定建仓": "确定建仓",
    "委托详情": "委托详情",
    "股票代码": "股票代码",
    "股票名称": "股票名称",
    "权利金比例": "权利金比例",
    "权利金": "权利金",
    "到期日期": "到期日期",
    "成交方式": "成交方式",
    "参考价格": "参考价格",
    "订单": "订单",
    "建仓价": "建仓价",
    "建仓数量": "建仓数量",
    "每份期权价格": "每份期权价格",
    "成交时间": "成交时间",
    "驳回": "驳回",
    "确定": "确定",
    "取消": "取消",
    "建仓数量": "建仓数量",
    "建仓数量": "建仓数量",
    "确定平仓": "确定平仓",
    "委托详情": "委托详情",
    "选择用户": "选择用户",
    "保存": "保存",
    "取消": "取消",
    "委托单": "委托单",
    "平仓价": "平仓价",
    "数量": "数量",
    "委托单": "委托单",
    "名义本金": "名义本金",
    "成交额": "成交额",
    "期权类型": "期权类型",
    "方向": "方向",
    "权利金": "权利金",
    "手续费": "手续费",
    "表单不完整": "表单不完整",
    "修改": "修改",
    "平仓": "平仓",
    "撤委": "撤委",
    "止盈": "止盈",
    "止损": "止损",
    "确认": "确认",
    "关闭": "关闭",
    "交易": "交易",
    "市场深度": "市场深度",
    "最高": "最高",
    "最低": "最低",
    "成交量": "成交量",
    "今开": "今开",
    "昨收": "昨收",
    "成交额": "成交额",
    "持仓量": "持仓量",
    "买一": "买一",
    "卖一": "卖一",
    "日增": "日增",
    "净值": "净值",
    "保证金": "保证金",
    "可用余额": "可用余额",
    "浮动盈亏": "浮动盈亏",
    "安全度": "安全度",
    "手数": "手数",
    "手": "手",
    "市价": "市价",
    "对手价": "对手价",
    "价格": "价格",
    "可开": "可开",
    "可平": "可平",
    "每手保证金": "每手保证金",
    "价格": "价格",
    "买多": "买多",
    "卖空": "卖空",
    "平仓": "平仓",
    "登录": "登录",
    "注册": "注册",
    "持仓": "持仓",
    "委托": "委托",
    "成交": "成交",
    "合约名称": "合约名称",
    "多空": "多空",
    "交易量": "交易量",
    "开仓价": "开仓价",
    "开仓时间": "开仓时间",
    "手续费": "手续费",
    "库存费": "库存费",
    "盈亏": "盈亏",
    "操作": "操作",
    "平仓": "平仓",
    "撤委": "撤委",
    "委托价": "委托价",
    "委托时间": "委托时间",
    "开仓价": "开仓价",
    "开仓时间": "开仓时间",
    "市场深度": "市场深度",
    "买": "买",
    "卖": "卖",
    "平仓价": "平仓价",
    "平仓时间": "平仓时间",
    "多": "多",
    "空": "空",

    //废弃的翻译 作为备用
    //-----------------------------------------------------------
    DelegateOrder: {
        a1: "搜索条件",
        a2: "关键词",
        a3: "姓名,邮箱或手机号",
        a4: "选择",
        a5: "品种",
        a6: "名称或代码",
        a7: "开始时间",
        a8: "结束时间",
        a9: "额外设置",
        a10: "是否包括下级",
        a11: "委托单类型",
        a12: "建仓委托",
        a13: "平仓委托",
        a14: "已锁定",
        a15: "分组",
        a16: "下拉选择分组",

        a17: "市场类型",
        a18: "下拉选择市场类型",
        a19: "股票",
        a20: "指数",
        a21: "商品",
        a22: "提交",

        b1: "统计",
        b2: "用户数",
        b3: "权利金",
        b4: "名义本金",
        b5: "条目数",
        b6: "场外期权",
        b7: "场内期权",
        b8: "数字货币",

        c1: "确定建仓",
        c2: "委托详情",
        c3: "股票代码",
        c4: "股票名称",
        c5: "权利金比例",
        c6: "权利金",
        c7: "到期日期",
        c8: "成交方式",
        c9: "参考价格",

        c11: "订单ID",
        c12: "建仓价",
        c13: "建仓数量",
        c14: "每份期权价格",
        c15: "成交时间",
        c16: "驳回",
        c17: "确定",
        c18: "取消",
        c19: "建仓数量",
        c20: "建仓数量",

        c21: "确定平仓",
        c22: "委托详情",
        c23: "选择用户",
        c24: "保存",
        c25: "取消",
        c26: "委托单",
        c27: "平仓价",
        c28: "数量",

        d1: "委托单",
        d2: "名义本金",
        d3: "成交额",
        d4: "期权类型",
        d5: "方向",
        d6: "权利金",
        d7: "手续费",
        d8: "表单不完整"
    },
    BitcoinTrading: {
        positionAction: {
            a1: "修改",
            a2: "平仓",
            a3: "撤委",
            a4: "止盈",
            a5: "止损",
            a6: "确认",
            a7: "关闭"
        },
        a1: "交易",
        a2: "市场深度",

        b1: "最高",
        b2: "最低",
        b3: "成交量",
        b4: "今开",
        b5: "昨收",
        b6: "成交额",
        b7: "持仓量",
        b8: "买一",
        b9: "卖一",
        b10: "日增",

        c1: "净值",
        c2: "保证金",
        c3: "可用余额",
        c4: "浮动盈亏",
        c5: "安全度",

        d1: "手数",
        d2: "手",
        d3: "市价",
        d4: "对手价",
        d5: "价格",

        d6: "可开",
        d7: "可平",
        d8: "每手保证金",
        d9: "价格",
        d10: "买多",
        d11: "卖空",
        d12: "平仓",
        d13: "登录",
        d14: "注册",

        e1: "持仓",
        e2: "委托",
        e3: "成交",

        e4: "合约名称",
        e5: "多空",
        e6: "交易量",
        e7: "开仓价",
        e8: "开仓时间",
        e9: "手续费",
        e10: "库存费",
        e11: "盈亏",
        e12: "操作",
        e13: "平仓",
        e14: "撤委",

        e15: "委托价",
        e16: "委托时间",

        ee15: "开仓价",
        ee16: "开仓时间",

        e17: "市场深度",
        e18: "买",
        e19: "卖",
        e20: "平仓价",
        e21: "平仓时间",

        f1: "多",
        f2: "空"
    },
    mine: {
        nav: {
            Deal: "交易",
            CustomerManagement: "客户管理",
            WithdrawDeposite: "出入金",
            ReportQuery: "报表查询",
            SystemConfig: "系统设置"
        },
        currentEquity: "当前权益",
        balance: "可用资金",
        premium: "持仓权利金",
        positiongl: "持仓盈亏",
        todayDeposit: "当日入金",
        todayWithdraw: "当日出金",

        qrcode: "二维码开户链接",
        sideMenu: {
            SettingInOut: "出入金设置",
            Subscribed: "期权认购",
            ListClientAdmin: "客户列表",
            CustomerAction: "客户行为",
            UnnormalMatch: "异常比赛",

            Deposite: "入金",
            Withdraw: "出金",
            UnCheckDeposite: "入金列表",
            UnCheckWithdraw: "出金列表",

            DelegateOrder: "委托单",
            RecordPosition: "持仓查询",
            RecordTrade: "成交记录",
            RecordStatistics: "统计报表",
            BillDetail: "资金流水",
            RecordCommission: "返佣报表",

            SettingRole: "角色管理",
            SettingGroup: "组管理",
            SettingRank: "返佣设置",
            SettingOrg: "机构管理",
            RecordLog: "日志",
            SettingSystem: "系统参数",
            SettingNotice: "公告管理",

            SubAccount: "子账户",
            Profile: "个人信息",
            pwdChange: "修改密码",

            logout: "退出账号"
        },
        a1: "净值",
        a2: "浮动盈亏",
        a3: "余额",
        a4: "可用余额",
        a5: "保证金",
        a6: "安全度"
    },
    Subscribed: {
        search: "请输入查询内容",
        cycle: "行权周期",
        notional: "名义本金",
        wan: "万",
        yuan: "元",
        hand: "手",
        about: "预估为",
        type: "类型",
        dealway: "成交方式",
        alwaysNow: "始终以当前价格成交",
        limitPrice: "限价",
        premium_ratio: "报价比例",
        payPrice: "支付金额",
        buy: "立即认购",
        setMoney: "请输入指定的价格",
        close: "关闭",
        submit: "提交"
    },
    deposite: {
        a1: "目标金额",
        doDeposite: "点击入金",

        setWay: "选择入金方式",
        setWay2: "选择出金方式",
        hint: "入金金额",

        wayList: {
            Transfer: "银联",
            Alipay: "支付宝",
            QuFuBao: "在线支付",
            Transfer1: "银联",
            Bitcoin: "比特币",
            Otcusdt: "场外USDT",
            Unionpay: "银联转账"

        },

        pay: "支付",
        zfbNotice: "注意：需按照订单金额使用本人支付宝账户进行扫码支付"
    },
    withdraw: {
        doWithdraw: "点击出金",
        setRange: "调整范围",
        hint: "请输入出金数额",

        notice_a: "请输入正确的数值",
        notice_b: "请输入出金数额",
        notice_c: "超过出金限额"
    },
    option: {
        up: "看涨期权",
        down: "看跌期权"
    },
    bannerTitle: {
        allStock: "全部股票",
        Subscribed: "期权交易"
    },
    notice: {
        realAuth: "请先完成实名认证",
        realAuth2: "请先完成实名认证",
        confirm: "点击认证",
        noFavorite: "自选为空"
    },
    footer: {
        home: "首页",
        market: "市场",

        optional: "自选",
        news: "资讯",
        mine: "我的"
    },
    homeTable: {
        updated_datetime: "时间",
        name: "名称",
        name_pair: "交易对",
        latest_p: "最新价",
        up_range: "涨跌幅",

        up_number: "涨跌",
        up_number_a: "涨跌价",

        now_p: "现价",
        buy_p: "买价",
        sale_p: "卖价",
        buy_v: "买量",
        sale_v: "卖量",
        deal_v: "成交量",
        money: "成交额",
        hold_v: "持仓量",
        dayRise: "日增",
        open: "开盘",
        high: "最高",
        low: "最低",
        close: "昨收",
        exchange: "交易所",
        symbol: "代码",

        contract_intro: "合约简介",
        max_volume: "最大交易量",
        amount_precision: "交易量精度",
        sale_datetime: "交易时间",
        contract_size: "合约大小",
        min_volume: "最小交易量",
        price_precision: "价格精度"
    },
    news: {
        quick: "市场快讯",
        calendar: "财经日历",
        rank: "交易排名"
    },
    tradeSymbol: {
        stock: "股票",
        index: "指数",
        goods: "商品",
        options: "期权",
        bitcoin: "数字货币",
        money: "法币"
    },
    moneyTable: {
        name: "姓名",
        bank: "银行",
        open_bank: "开户行",
        card_code: "银行卡号",
        money: "金额",
        info_d: "转入信息",
        id: "订单号",
        way_d: "支付方式",
        status: "状态",
        time: "时间",
        msg: "备注"
    },
    statistical: "统计",
    totalMoney: "金额总计",
    listNum: "条目",
    submit: "提交",
    close: "关闭",
    seeMore: "查看更多",
    action: "操作",
    delFav: "移除自选",
    jin10: {
        a1: "日期",
        a2: "前值",
        a3: "今值",
        a4: "预测值",
        a5: "万人"
    },
    fourReport: {
        flow: "股票资金流向",
        report: "中国CPI月报告",
        daily: "期货仓单日报",
        store: "美国EIA库存",

        a1: "美联储决议",
        a2: "美国非农报告",
        a3: "全球法币热度",
        a4: "数字货币概览"
    },
    logReg: {
        a1: "手机号",
        a2: "密码",
        a3: "验证码",
        a4: "登录",
        a5: "注册",

        b1: "忘记密码",
        b2: "新密码",
        b3: "确认密码",
        b4: "手机号",
        b5: "验证码",
        b6: "获取验证码",
        b7: "提交",
        b8: "清空表单",

        c1: "推荐码",
        c2: "邮箱",

        d1: "原密码"
    },
};
export default zh;


// WEBPACK FOOTER //
// ./src/i18n/config/zh.js